import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-products.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {LoadEcommerceProducts} from "../actions";

@Injectable()
export class EcommerceEffect {

  loadEcommerceProducts$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_PRODUCTS),
    mergeMap((action: LoadEcommerceProducts) => {
      const {websiteId, ...params} = action.payload;
      return this._ecommerceService.getProducts(websiteId, params)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceProductsSuccess({
                websiteId,
                entities: response.data.products,
                productsCount: response.data.productsTotals || 0
              });
            }
            return new EcommerceActions.LoadEcommerceProductsFails({websiteId});
          })
        );
    })
  ));

  /* @Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
     .pipe(
       filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
       map((action: UpdateWebsiteSubData) => {
         return new hostingRedirectsActions.LoadRedirects(action.payload.id);
       })
     );*/

  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
    private _ordersService: EcommerceService,
  ) {
  }

}
